import { createSlice } from "@reduxjs/toolkit";

//STATE
const state = {
  rows: [],
  itemsEdit: {},
  isLoading: false,
  showDialog: false,
  itemTypesList: [],
  itemStatusList: [],
  itemCategoriesList: [],
};

//STORE SLICE
export const itemsEditSlice = createSlice({
  name: "itemsEditSlice",
  initialState: state,
  //REDUCER
  reducers: {
    showEditItemsDialog(state, action) {
      return {
        ...state,
        showDialog: true,
        itemsEdit: action.payload,
      };
    },
    closeEditItemsDialog(state) {
      return {
        ...state,
        showDialog: false,
      };
    },
    showLoading(state) {
      return {
        ...state,
        isLoading: true,
      };
    },
    hideLoading(state) {
      return {
        ...state,
        isLoading: false,
      };
    }, 
    setItemTypesList(state, action) {
      return {
        ...state,
        itemTypesList: action.payload
      }
    },
    setItemStatusList(state, action) {
      return {
        ...state,
        itemStatusList: action.payload
      }
    },
    setItemCategoriesList(state, action) {
      return {
        ...state,
        itemCategoriesList: action.payload
      }
    }, 
  },
});

//ACTIONS
export const {
  showEditItemsDialog,
  closeEditItemsDialog,
  showLoading,
  hideLoading,
  setItemTypesList,
  setItemStatusList,
  setItemCategoriesList,
} = itemsEditSlice.actions;

export default itemsEditSlice.reducer;
